module.exports = __webpack_public_path__ + "img/wx.76ec2b3b.jpg";